// extracted by mini-css-extract-plugin
export var dark = "v_sy";
export var darkcookie = "v_sz";
export var tintedcookie = "v_sB";
export var regularcookie = "v_sC";
export var darkbase = "v_sD";
export var tintedbase = "v_sF";
export var regularbase = "v_sG";
export var darkraw = "v_sH";
export var tintedraw = "v_sJ";
export var regularraw = "v_sK";
export var darkchick = "v_sL";
export var tintedchick = "v_sM";
export var regularchick = "v_sN";
export var darkherbarium = "v_sP";
export var tintedherbarium = "v_sQ";
export var regularherbarium = "v_sR";
export var darkholiday = "v_sS";
export var tintedholiday = "v_sT";
export var regularholiday = "v_sV";
export var darkoffline = "v_sW";
export var tintedoffline = "v_sX";
export var regularoffline = "v_sY";
export var darkorchid = "v_sZ";
export var tintedorchid = "v_s0";
export var regularorchid = "v_s1";
export var darkpro = "v_s2";
export var tintedpro = "v_s3";
export var regularpro = "v_s4";
export var darkrose = "v_s5";
export var tintedrose = "v_s6";
export var regularrose = "v_s7";
export var darktimes = "v_s8";
export var tintedtimes = "v_s9";
export var regulartimes = "v_tb";
export var darkwagon = "v_tc";
export var tintedwagon = "v_td";
export var regularwagon = "v_tf";